// @flow

import styled from 'styled-components';

import Button from 'components/shared/button';
import { TYPE_SCALE_F1 } from 'styles/type-scale';
import { FONT_WEIGHT_700 } from 'styles/font-weight';
import { CLARK_SECONDARY, BACKGROUND_COLOR_TERTIARY } from 'styles/colors';
import { LINE_HEIGHT_COPY } from 'styles/line-height';
import {
  SPACING_EXTRA_EXTRA_LARGE,
  SPACING_LARGE,
  SPACING_MEDIUM,
  SPACING_SMALL,
} from 'styles/spacing';
import media from 'styles/media-queries';
import { EngagementEmpty } from '../empty';

const MAX_WIDTH = '368px';
export const HeaderBackground = styled.div`
  background-color: ${BACKGROUND_COLOR_TERTIARY};
  width: 100%;
  padding: ${SPACING_LARGE} 0;
`;

export const Logo = styled.img`
  display: block;
  width: ${SPACING_EXTRA_EXTRA_LARGE};
`;

export const Headline = styled.div`
  ${TYPE_SCALE_F1};
  ${FONT_WEIGHT_700};
  ${LINE_HEIGHT_COPY};
  color: ${CLARK_SECONDARY};
  margin: ${SPACING_LARGE} 0 calc(${SPACING_MEDIUM} + ${SPACING_SMALL}) 0;
`;

export const ButtonContainer = styled<any>(Button)`
  max-width: ${MAX_WIDTH};
  text-align: center;
  margin-left: 0;
  width: 100%;
`;

export const EngagementMsgLg = styled<any>(EngagementEmpty)`
  display: none;

  ${media.small`
    display: block;
  `};
`;

export const EngagementMsgSmall = styled.div`
  ${media.small`
    display: none;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/sessions/list/header/styles.js